import Cookies from 'js-cookie'

// The currency the storefront is showing, shared outside the Pinia store so that services (GraphQL header)
// can read it without importing the store. Null until the store has resolved a currency.
let activeCurrency: string | null = null

export function setActiveCurrency(code: string | null | undefined): void {
  activeCurrency = code ? String(code).toUpperCase() : null
}

export function getActiveCurrency(): string | null {
  return activeCurrency
}

// The page currency sent with priced requests: core-service (X-CurrencyType) and PHP (pageCurrency) get the
// same value. The cookie is only a fallback before the store has resolved a currency.
export function pageCurrency(): string {
  return activeCurrency || Cookies.get('currency')?.toUpperCase() || 'USD'
}
